import { PATIENT_MESH_DPA_MARKDOWN } from "../legal/patientMeshDpaAgreementText";

function simpleMarkdownToHtml(markdown) {
  let html = markdown;

  // Replace Headers
  html = html.replace(/^# (.*$)/gim, "<h1>$1</h1>");
  html = html.replace(/^### (.*$)/gim, "<h3>$1</h3>");
  html = html.replace(/^## (.*$)/gim, "<h2>$1</h2>");

  // Replace Bold
  html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

  // Replace Horizontal Rules
  html = html.replace(/^---$/gim, "<hr>");

  // Replace Tables (markdown table parser)
  const lines = html.split("\n");
  let inTable = false;
  let tableHtml = "";
  let resultLines = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (line.startsWith("|") && line.endsWith("|")) {
      if (line.includes("---")) continue; // Skip table header delimiter line
      const cells = line.split("|").slice(1, -1).map((c) => c.trim());
      if (!inTable) {
        inTable = true;
        tableHtml =
          "<table><thead><tr>" +
          cells.map((c) => `<th>${c}</th>`).join("") +
          "</tr></thead><tbody>";
      } else {
        tableHtml +=
          "<tr>" + cells.map((c) => `<td>${c}</td>`).join("") + "</tr>";
      }
    } else {
      if (inTable) {
        inTable = false;
        tableHtml += "</tbody></table>";
        resultLines.push(tableHtml);
        tableHtml = "";
      }
      if (line.startsWith("* ")) {
        resultLines.push(`<li>${line.substring(2)}</li>`);
      } else if (
        line.length > 0 &&
        !line.startsWith("<h") &&
        !line.startsWith("<hr")
      ) {
        resultLines.push(`<p>${line}</p>`);
      } else {
        resultLines.push(line);
      }
    }
  }
  if (inTable) {
    tableHtml += "</tbody></table>";
    resultLines.push(tableHtml);
  }

  return resultLines.join("\n");
}

export function openDpaInNewTab(dpaDetails = {}) {
  try {
    const newWin = window.open("", "_blank");
    if (!newWin || newWin.closed || typeof newWin.closed === "undefined") {
      return false;
    }

    let md = PATIENT_MESH_DPA_MARKDOWN;
    md = md.replace(
      /{{DATA_CONTROLLER_TITLE_NAME}}/g,
      dpaDetails.titleName || "Hekim / Kurumsal Sağlık Kuruluşu"
    );
    md = md.replace(
      /{{AUTHORIZED_PERSON}}/g,
      dpaDetails.authorizedPerson || "Hekim / Kurum Yetkilisi"
    );
    md = md.replace(
      /{{ACCEPTANCE_DATE}}/g,
      dpaDetails.acceptanceDate || "Kayıt Anında Onaylandı"
    );
    md = md.replace(
      /{{SUBPROCESSOR_NAME}}/g,
      dpaDetails.subprocessorName || "Google LLC / Cloud Provider"
    );
    md = md.replace(
      /{{SERVICE_TYPE}}/g,
      dpaDetails.serviceType || "Bulut Altyapı & Siber Güvenlik"
    );
    md = md.replace(
      /{{PROCESSED_DATA}}/g,
      dpaDetails.processedData || "Sistem / Oturum / Güvenlik Logları"
    );
    md = md.replace(
      /{{HOSTING_COUNTRY}}/g,
      dpaDetails.hostingCountry || "Türkiye / AB"
    );
    md = md.replace(
      /{{TRANSFER_MECHANISM}}/g,
      dpaDetails.transferMechanism || "Standart Sözleşme (KVKK m.9)"
    );
    md = md.replace(
      /{{SECURITY_MEASURE}}/g,
      dpaDetails.securityMeasure || "AES-256 / TLS 1.3 / ISO 27001"
    );

    const bodyHtml = simpleMarkdownToHtml(md);

    const fullHtml = `<!DOCTYPE html>
<html lang="tr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>PatientMesh Veri İşleme Sözleşmesi (DPA)</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
      background-color: #f8fafc;
      color: #1e293b;
      line-height: 1.6;
      padding-top: 70px;
      padding-bottom: 40px;
    }
    .top-header {
      position: fixed;
      top: 0; left: 0; right: 0;
      height: 60px;
      background-color: #0f172a;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      z-index: 1000;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.15);
    }
    .brand-title {
      font-size: 1.05rem;
      font-weight: 700;
      color: #38bdf8;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .actions {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .btn {
      padding: 8px 18px;
      font-size: 0.85rem;
      font-weight: 600;
      border-radius: 6px;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;
      text-decoration: none;
    }
    .btn-print {
      background-color: #0284c7;
      color: #ffffff;
    }
    .btn-print:hover {
      background-color: #0369a1;
    }
    .btn-close {
      background-color: #334155;
      color: #f8fafc;
    }
    .btn-close:hover {
      background-color: #475569;
    }
    .content-container {
      max-width: 900px;
      margin: 0 auto;
      background-color: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 40px;
      box-shadow: 0 10px 25px rgba(15, 23, 42, 0.05);
    }
    h1 { font-size: 1.5rem; color: #0f172a; margin-bottom: 8px; border-bottom: 2px solid #0f172a; padding-bottom: 10px; }
    h2 { font-size: 1.25rem; color: #0f172a; margin-top: 24px; margin-bottom: 12px; }
    h3 { font-size: 1.1rem; color: #1e293b; margin-top: 20px; margin-bottom: 10px; }
    p { margin-bottom: 14px; font-size: 0.95rem; color: #334155; }
    li { margin-left: 20px; margin-bottom: 6px; font-size: 0.95rem; color: #334155; }
    hr { border: none; border-top: 1px solid #e2e8f0; margin: 24px 0; }
    table { width: 100%; border-collapse: collapse; margin: 20px 0; font-size: 0.9rem; }
    th, td { border: 1px solid #cbd5e1; padding: 10px 14px; text-align: left; vertical-align: top; }
    th { background-color: #f1f5f9; color: #0f172a; font-weight: 700; }
    tr:nth-child(even) td { background-color: #f8fafc; }

    @media print {
      .top-header { display: none !important; }
      body { padding: 0; background-color: #ffffff; }
      .content-container { border: none; box-shadow: none; padding: 0; max-width: 100%; }
      @page { margin: 15mm; }
    }
  </style>
</head>
<body>
  <div class="top-header">
    <div class="brand-title">
      🛡️ PatientMesh • Veri İşleme Sözleşmesi (DPA)
    </div>
    <div class="actions">
      <button class="btn btn-print" onclick="window.print()">🖨️ PDF Olarak İndir / Yazdır</button>
      <button class="btn btn-close" onclick="window.close()">Kapat</button>
    </div>
  </div>

  <div class="content-container">
    ${bodyHtml}
  </div>
</body>
</html>`;

    newWin.document.open();
    newWin.document.write(fullHtml);
    newWin.document.close();
    newWin.focus();
    return true;
  } catch (err) {
    console.error("Window open error:", err);
    return false;
  }
}
